
/* ===== Global wishlist click handler (disabled on wishlist page) ===== */
(function () {
  // Skip entirely if disabled or already wired
  if (window.WA_WISHLIST_WIRED || window.WA_WISHLIST_DISABLE_GLOBAL) return;
  window.WA_WISHLIST_WIRED = true;

  function ensureLoginModal(){ /* no-op; your site injects this elsewhere */ }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-wa-card-fave]');
    if (!btn) return;

    // Hard bail on the dedicated wishlist page – let that page’s script own the UI.
    if (btn.closest('.wa-wl')) return;

    e.preventDefault(); 
    e.stopPropagation();

    if (!window.WA_LOGGED_IN) {
      if (typeof ensureLoginModal === 'function') ensureLoginModal();
      if (window.WA_OPEN_LOGIN) WA_OPEN_LOGIN();
      return;
    }

    const productId = btn.getAttribute('data-product-gid');
    const customerId = window.WA_CUST_ID;
    const turningOn = !btn.classList.contains('is-on');

    btn.disabled = true;
    try {
      const r = await fetch(window.WA_WISHLIST_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: turningOn ? 'add' : 'remove',
          customerId,
          productId
        })
      });
      const j = await r.json();

      if (!r.ok || !j?.ok) throw new Error('Wishlist API error');

      // Update UI state
      btn.classList.toggle('is-on', j.isOn);
      btn.setAttribute('aria-pressed', j.isOn ? 'true' : 'false');

      let cnt = btn.querySelector('[data-like-count]');
      if (!cnt) {
        cnt = document.createElement('span');
        cnt.className = 'wa-card-like-count';
        cnt.setAttribute('data-like-count','');
        btn.appendChild(cnt);
      }
      const n = Number(j.count || 0);
      cnt.textContent = String(n);
      n <= 0 ? cnt.setAttribute('hidden','') : cnt.removeAttribute('hidden');
    } catch (err) {
      console.error(err);
    } finally {
      btn.disabled = false;
    }
  }, true);
})();

/* ===== Global counts refresher (disabled on wishlist page) ===== */
(function () {
  if (window.WA_WISHLIST_COUNTS_WIRED || window.WA_WISHLIST_DISABLE_GLOBAL) return;
  window.WA_WISHLIST_COUNTS_WIRED = true;

  async function refreshCounts() {
    try {
      const cards = Array.from(document.querySelectorAll('[data-wa-card-fave][data-product-gid]'));
      if (!cards.length) return;

      const ids = cards.map(el => el.getAttribute('data-product-gid'));
      const batches = [];
      const size = 40;
      for (let i = 0; i < ids.length; i += size) batches.push(ids.slice(i, i + size));

      for (const batch of batches) {
        const url = `${window.WA_WISHLIST_ENDPOINT}/counts?ids=${encodeURIComponent(batch.join(','))}`;
        const r = await fetch(url, { method: 'GET' });
        const j = await r.json();
        if (!j?.counts) continue;

        for (const id of batch) {
          const btn = document.querySelector(`[data-wa-card-fave][data-product-gid="${CSS.escape(id)}"]`);
          if (!btn) continue;

          // If this button is on the wishlist page, skip (page script manages it)
          if (btn.closest('.wa-wl')) continue;

          let cnt = btn.querySelector('[data-like-count]');
          if (!cnt) {
            cnt = document.createElement('span');
            cnt.className = 'wa-card-like-count';
            cnt.setAttribute('data-like-count', '');
            btn.appendChild(cnt);
          }
          const n = Number(j.counts[id] || 0);
          cnt.textContent = String(n);
          n <= 0 ? cnt.setAttribute('hidden', '') : cnt.removeAttribute('hidden');
        }
      }
    } catch (e) {
      console.warn('wishlist counts fetch failed', e);
    }
  }

  // Do not hydrate counts on the wishlist page
  if (!document.querySelector('.wa-wl')) {
    document.addEventListener('DOMContentLoaded', refreshCounts);
  }
})();